<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Socio #' + this.$route.params.id : 'Nuovo socio')">

                    <b-container fluid class="mx-auto text-left" v-if="showdettaglio || (socio.id == null && showdettaglio3)">
                         <b-row class="my-1">
                                    <b-col sm="3"><label for="cognome">Cognome:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="isVismenuZ()" v-model="socio.cognome" id="cognome" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="nome">Nome:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="isVismenuZ()" v-model="socio.nome" id="nome" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="account">N° Socio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="isVismenuZ()" v-model="socio.account" id="account" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="codfiscale">Codice fiscale:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="isVismenuZ()" v-model="socio.codfiscale" id="codfiscale" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="email">Email:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="isVismenuZ()" v-model="socio.email" id="email" type="email"></b-form-input>
                                    </b-col>
                                </b-row>
                              <!--   <b-row class="my-1" v-if="showpassword">
                                    <b-col sm="3"><label for="password">Password:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="socio.password" id="password" type="password"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-if="showpassword">
                                    <b-col sm="3"><label for="ripetipassword">Ripeti password:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="ripetipassword" id="ripetipassword" type="password"></b-form-input>
                                    </b-col>
                                </b-row> -->
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="sede">Sede:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="isVismenuZ()" v-model="socio.sede" id="sede" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgsocio">Profilo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select :disabled="isVismenuZ()" v-model="socio.flgsocio" :options="options_profilo" id="flgsocio">

                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgatt">Attivo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="socio.flgatt" :options="options_attivo" id="flgatt">

                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgruolo">Ruolo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select :disabled="isVismenuZ()" v-model="socio.flgruolo" :options="options" id="flgruolo">

                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="socio.flgruolo == 'A'">
                                    <b-col sm="3">
                                        <span id="vismenu-tooltip" class="d-inline-block" tabindex="0">
                                            <label for="vismenu">Limitazioni menù:</label>
                                        </span>
                                        <b-tooltip target="vismenu-tooltip" triggers="hover">
                                            Inserire separati da virgola i valori:<br>
                                            T = Categorie<br>
                                            <!-- C = Convenzioni<br> -->
                                            E = Eventi<br>
                                            S = Soci<br>
                                            Z = Attiva/Disattiva Soci<br>
                                            <!-- P = Pagamenti<br>
                                            O = Sconti<br> -->
                                            D = Documenti<br>
                                            <!-- I = Impianti<br> -->
                                            <!-- A = Abbonamenti<br> -->
                                            Q = Questionari<br>
                                            U = Push Notification<br>
                                            N = News<br>
                                            B = Bancarella<br>
                                            L = Modulistica<br>
                                            <!-- R = Prenotazioni<br> -->
                                            M = Parametri<br>
                                            <!-- RL = Rimborso Libri<br> -->
                                        </b-tooltip>
                                    </b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="isVismenuZ()" v-model="socio.vismenu" id="vismenu" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="socio.flgruolo == 'A'">
                                    <b-col sm="3">
                                        <span id="viscategoria-tooltip" class="d-inline-block" tabindex="0">
                                            <label for="viscategoria">Limitazioni categorie:</label>
                                        </span>
                                        <b-tooltip target="viscategoria-tooltip" triggers="hover">
                                            Inserire separati da virgola gli ID (campo #) delle categorie
                                        </b-tooltip>
                                    </b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="isVismenuZ()" v-model="socio.viscategoria" id="viscategoria" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="azienda">Azienda:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="isVismenuZ()" v-model="socio.azienda" id="azienda" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="sso">SSO:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="isVismenuZ()" v-model="socio.sso" id="sso" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="cell">Cellulare:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="isVismenuZ()" v-model="socio.cell" id="cell" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="indirizzo">Indirizzo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea :disabled="isVismenuZ()" v-model="socio.indirizzo" id="indirizzo" rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>
<!--                                 <b-row class="my-1" v-if="socio.id != null">
                                    <b-col sm="3"><label for="descrgdpr">Accettazione GDPR da App:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="socio.descrgdpr" id="descrgdpr" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row> -->
                                <b-row class="my-1" v-if="socio.id != null">
                                    <b-col sm="3"><label for="datins">Data inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="socio.datins" id="datins" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-3" v-if="!isVismenuZ()">
<!--                                     <b-col sm="5" offset-sm="3" v-show="socio.id != null && parametri != null && parametri.flgparenti == 'S'">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="parenti()">
                                            Parenti
                                        </b-button>
                                    </b-col> -->
                                    <b-col offset-sm="3" sm="5" v-show="socio.id != null && parametri != null && parametri.flgdocumenti == 'S'">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="documenti()">
                                            Documenti
                                        </b-button>
                                    </b-col>
<!--                                     <b-col sm="4" v-show="socio.id != null">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="storico()">
                                            Storico
                                        </b-button>
                                    </b-col> -->
                                </b-row>
<!--                            <b-row class="my-3" v-if="!isVismenuZ()">
                                     <b-col sm="5" offset-sm="3" v-show="socio.id != null">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="pagamenti()">
                                            Pagamenti
                                        </b-button>
                                    </b-col>
                                </b-row> -->
<!--                                 <b-row class="my-3" v-if="!isVismenuZ()">
                                    <b-col sm="9" offset-sm="3" v-show="socio.id != null && parametri != null && parametri.flgabbonamenti == 'S'">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="abbonamenti()">
                                            Abbonamenti
                                        </b-button>
                                    </b-col>
                                </b-row> -->
                                <b-row class="my-3">
                                    <b-col sm="5" offset-sm="3" >
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="socio.id != null">
                                                Salva
                                            </div>
                                            <div v-else>
                                                Inserisci
                                            </div>
                                        </b-button>
                                    </b-col>
                                    
                                    <b-col sm="4" v-show="socio.id != null">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="storico()">
                                            Storico
                                        </b-button>
                                    </b-col>
                                    
<!--                                     <b-col sm="4" v-show="socio.id != null && !showpassword">
                                        <b-button v-if="!isVismenuZ()" block size="md" variant="outline-danger" v-on:click="cambiaPassword()">
                                            Cambia password
                                        </b-button>
                                    </b-col> -->
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>

import {
    NAMESPACE,
} from '../config.js'

import {
    Socio,
} from '../classes.js'

import {
    ctrlVismenu
} from '../util.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {

            namespace: NAMESPACE,
            socio: {
                id: this.$route.params.id || null,
                nome: '',
                cognome: '',
                account: '',
                codfiscale: '',
                email: '',
                password: '',
                flgatt: 'S',
                sede: '',
                azienda: '',
                sso: '',
                cell: '',
                indirizzo: '',
                flgsocio: 'I',
                flgruolo: 'U',
                vismenu: '',
                viscategoria: '',
                datins: null
            },
            parametri: null,
            options: [],
            options_profilo: [],
            options_attivo: [

            ],
            error: '',
            showerror: false,
            showdettaglio: false,
            showdettaglio3: false,
            dismissSecs: 2,
            dismissCountDown: 0,
            showpassword: false, //(this.$route.params.id == null),
            ripetipassword: '',
        };
    },
    watch: {
        'socio.codfiscale': function(val, oldVal) {
            this.socio.codfiscale = val.toUpperCase();
        }
    },
    methods: {
        isVismenuZ(){
            return ctrlVismenu("Z");
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        cambiaPassword() {
            this.socio.password = '';
            this.ripetipassword = '';
            this.showpassword = true;
        },
        getRuoli() {

            var sc = new Socio();
            var tipi = sc.getListaRuoli();
            var keys = Object.keys(tipi);
            var options = [];
            for (var i = 0; i < keys.length; i++) {
                options.push({
                    value: keys[i],
                    text: tipi[keys[i]]
                });
            }

            return options;

        },
        getProfili() {

            var sc = new Socio();
            var tipi = sc.getListaProfili();
            var keys = Object.keys(tipi);
            var options = [];
            for (var i = 0; i < keys.length; i++) {
                options.push({
                    value: keys[i],
                    text: tipi[keys[i]]
                });
            }

            return options;

        },
        getFlgsoci() {

            var sc = new Socio();
            var tipi = sc.getListaFlgatt();
            var keys = Object.keys(tipi);
            var options = [];
            for (var i = 0; i < keys.length; i++) {
                options.push({
                    value: keys[i],
                    text: tipi[keys[i]]
                });
            }

            return options;

        },
        documenti() {

            this.$router.push({
               path: `/app/documenti/id_socio/${this.socio.id}`
            });

        },
        pagamenti() {

            this.$router.push({
               path: `/app/pagamenti/id_socio/${this.socio.id}`
            });

        },
        abbonamenti() {
            this.$router.push({
               path: `/app/abbonamenti/id_socio/${this.socio.id}`
            });
        },
        storico() {

            this.$router.push({
               path: `/app/storico/id_socio/${this.socio.id}`
            });

        },
        parenti() {

            this.$router.push({
               path: `/app/parenti/id_socio/${this.socio.id}`
            });

        },
        insert() {

                var appdettaglio = this;

                // if (this.socio.email == "") {
                //     appdettaglio.showerror = true;
                //     appdettaglio.error = "Campo email vuoto!";

                // } else
                if (this.socio.account == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo N° Socio vuoto!";

                } else if (this.socio.nome == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo nome vuoto!";

                } else if (this.socio.cognome == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo cognome vuoto!";

                } /* else if (this.parametri.flgcfsocio == "S" && this.socio.codfiscale == "" &&
                    !(this.parametri.codfisiscrittoopt == "S" && this.socio.flgsocio == "I") ){ //se non è iscritto con cf opzionale
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo codice fiscale vuoto!";

                } */
/*                 else if (this.parametri.flgindsocio == "S" && this.socio.indirizzo == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo indirizzo vuoto!";

                } else if (this.parametri.flgcellsocio == "S" && this.socio.cell == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo cellulare vuoto!";

                } else if (this.showpassword && (this.socio.password == null || this.socio.password.trim().length < 8)) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "La password deve essere almeno 8 caratteri!";

                } else if (this.showpassword && this.socio.password != this.ripetipassword) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "I campi password e ripeti password non sono uguali!";

                }  */

                else {

                    var socioAux = this.socio;
                    if (!this.showpassword) {
                        delete socioAux.password;
                    }

                    var json = JSON.stringify(socioAux);

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/socio', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        this.showpassword = false;
                                        this.socio = res[0];
                                        this.showerror = false;
                                        this.showdettaglio = true; //anche se nodettagliosocion dovrebbe servire
                                        this.dismissCountDown = this.dismissSecs;

                                        this.$router.replace('/app/dettagliosocio/' + this.socio.id);

                                        setTimeout(function() {
                                            //window.history.back();
                                            appdettaglio.$router.go(-1);
                                        }, 2500);

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                appdettaglio.showerror = true;
                                appdettaglio.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });
                }



            }


    },
    created: function () {



        if(!ctrlVismenu("S")&&!ctrlVismenu("Z")){
            this.$router.replace('/accessdenied');
            return;
        }


            this.options_profilo = this.getProfili();
            this.options = this.getRuoli();

            this.options_attivo = this.getFlgsoci();

            var id = this.socio.id; //se è la prima volta si prova a prendere da getid

            if (id != null) {

                var token = localStorage.getItem('token');
                var appdettaglio = this;

                this.axios.get(NAMESPACE + 'rest/soci/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.socio = res[0];
                                    this.socio.descrgdpr = (this.socio.acpgdprapp == 'S' ? "Sì" : "No") + (this.socio.acpgdprapp == 'S' ? " - " + this.socio.dataacpgdprapp : "");
                                    //console.log("Res: " + JSON.stringify(this.socio ))
                                    this.showdettaglio = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

            //if(id == null){

                //PAREMETRI
                var token = localStorage.getItem('token');
                var appdettaglio = this;

                this.axios.get(NAMESPACE + 'rest/cral', {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;

                                if (typeof res == "object") {

                                    appdettaglio.parametri = res;
                                    this.parametri = res;

                                    if(id == null){
                                        appdettaglio.socio.flgatt = this.parametri.flgsocioattivodef;
                                    }

                                    appdettaglio.showdettaglio3 = true;

                                } else {
                                    throw new Error("Errore parametri non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
            //}

    },
    mounted: function() {


    }

}
</script>
